var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10C18.3334 14.6024 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6024 1.66675 10C1.66675 5.39762 5.39771 1.66666 10.0001 1.66666C14.6025 1.66666 18.3334 5.39762 18.3334 10ZM5.83342 10C5.83342 12.3012 7.6989 14.1667 10.0001 14.1667C12.3013 14.1667 14.1667 12.3012 14.1667 10C14.1667 7.69881 12.3013 5.83333 10.0001 5.83333C7.6989 5.83333 5.83342 7.69881 5.83342 10Z",
    fill: "#35DB80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10C18.3334 11.6482 17.8447 13.2593 16.929 14.6298C16.0133 16.0002 14.7118 17.0683 13.1891 17.699C11.6664 18.3297 9.99084 18.4948 8.37433 18.1732C6.75782 17.8517 5.27296 17.058 4.10753 15.8926C2.94209 14.7271 2.14841 13.2423 1.82687 11.6258C1.50533 10.0092 1.67036 8.33369 2.30109 6.81097C2.93182 5.28825 3.99992 3.98676 5.37033 3.07108C6.74074 2.15541 8.3519 1.66666 10.0001 1.66666V5.83333C9.17599 5.83333 8.37041 6.0777 7.68521 6.53554C7 6.99338 6.46595 7.64412 6.15058 8.40548C5.83522 9.16684 5.7527 10.0046 5.91348 10.8129C6.07425 11.6211 6.47108 12.3636 7.0538 12.9463C7.63652 13.529 8.37895 13.9258 9.18721 14.0866C9.99546 14.2474 10.8332 14.1649 11.5946 13.8495C12.356 13.5341 13.0067 13.0001 13.4645 12.3149C13.9224 11.6297 14.1667 10.8241 14.1667 10H18.3334Z",
    fill: "#0099DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7936 16.8166C15.8908 16.0451 16.7855 15.0201 17.4018 13.8288C18.018 12.6374 18.3376 11.3149 18.3334 9.97363L14.1667 9.98682C14.1688 10.6575 14.0091 11.3187 13.7009 11.9144C13.3928 12.51 12.9454 13.0225 12.3969 13.4083L14.7936 16.8166Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.3dee64e10bafa1453b420fe4bb6cf7bc.svg";
export { ForwardRef as ReactComponent };